// src/components/Login.js
import React, { useState } from "react";
  import { useNavigate } from 'react-router-dom';
import { useAuth } from "../contexts/AuthContext";

const Login = () => {
    const navigate = useNavigate();

  const { loginWithGoogle } = useAuth();

  const handleGoogleLogin = async () => {
    try {
      await loginWithGoogle();
      navigate("/dashboard");
      console.log("Ok logged in")
    } catch (error) {
      console.error("Failed to log in with Google", error);
    }
  };

  return (
      <button type="button" onClick={handleGoogleLogin}>Login with Google</button>
  );
};

export default Login;